import React, { useState } from 'react'
import { useSearchConditionPc } from '../hooks/useSearchCondition'
import { Select, SelectProps } from 'antd'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'
import { SearchConditionsParams } from '@/component/FilterCommon/hooks/useSearchCondition'


export interface SelectWarehousePcProps extends SelectProps {
  collaborator_company_id?: number //运营商公司id

}
const FilterSelectWarehousePc = (props: SelectWarehousePcProps) => {

  const { value, placeholder = '全部仓库',collaborator_company_id,allowClear=true , ...rest } = props;
  let isAffilliate = collaborator_company_id !== undefined
  type ParamsType = {purchase:['stock'],affiliate_situation:['stock']}
  // type ParamsType = {purchase:['stock'],affiliate_situation:['stock']}
  let params = { purchase: ['stock'] } as ParamsType
  if(isAffilliate){
    params = {
      affiliate_situation:['stock']
    } as ParamsType
  }
  const { searchCondition, loading, getInitData } = useSearchConditionPc(params);
  let options =  searchCondition.purchase?.stock
  if(isAffilliate && collaborator_company_id !== undefined){
   let affiliateStock = searchCondition.affiliate_situation?.stock || {}
   let stock = affiliateStock[collaborator_company_id] || []
   options = stock
  }
  
  return (
    <FilterSelectPc
      allowClear={allowClear}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      style={{ width: '100%' }}
      value={value}
      placeholder={placeholder}
      mode='multiple'
      // options={searchCondition.purchase?.stock}
      options={ options }
      getInitData={getInitData}
      loading={loading}
      {...rest}
    />
  )
}

export default FilterSelectWarehousePc;
